import React, { useState, useEffect } from 'react';
import styled from 'styled-components/macro';
import { useSnackbar } from 'notistack';
import { Link, useParams, useLocation } from 'react-router-dom';
import { spacing } from '@mui/system';
import { Breadcrumbs as MuiBreadcrumbs, Typography, Box, Link as MuiLink } from '@mui/material';
import { PATH_SUPPLIER } from '../../constants';
import CreateSupplier from '../../components/supplier/SupplierFormComponents/SupplierDetails/CreateSupplier';
import { supplierAPI } from '../../services';
import useLogOut from '../../hooks/useLogOut';

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const SupplierFormPage: React.FC = () => {
  // USE HOOKS
  const { id } = useParams();
  const { pathname } = useLocation();
  const { enqueueSnackbar } = useSnackbar();
  const [errStatus, setErrStatus] = useState(null);
  const { logOut } = useLogOut(errStatus);
  // CONST
  const isEdit = pathname.includes('edit');
  // FETCH SUPPLIER
  const { data: supplierData = {}, error } = supplierAPI.useFetchSupplierQuery(
    { id },
    { skip: !isEdit, refetchOnMountOrArgChange: true }
  );
  // HANDLERS
  const errorHandler = (error: any) => {
    let message: string | any = 'Something went wrong!';
    if (error?.data?.errors) {
      const msg = Object.values(error?.data?.errors).map((item: any) => item?.message || item);
      message = msg[0];
    }
    if (error?.originalStatus === 401) {
      setErrStatus(error?.originalStatus);
      message = 'You are not authorized!';
    }
    enqueueSnackbar(message, {
      variant: 'error'
    });
  };
  // HOOKS
  useEffect(() => {
    if (error) errorHandler(error);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);
  useEffect(() => {
    if (errStatus && typeof logOut === 'function') {
      logOut();
    }
  }, [errStatus, logOut]);
  return (
    <React.Fragment>
      <Box sx={{ mb: 5 }}>
        <Typography variant="h3" gutterBottom>
          {isEdit ? 'Edit Supplier Details' : 'Add Supplier Details'}
        </Typography>
        <Breadcrumbs>
          <MuiLink component={Link} to={PATH_SUPPLIER.ROOT}>
            Phoenix Waste Collection
          </MuiLink>
          <Typography>{!isEdit ? 'New supplier' : 'Edit supplier'}</Typography>
        </Breadcrumbs>
      </Box>
      <CreateSupplier
        isEdit={isEdit}
        supplier={{
          supplier: {
            id: null,
            company_name: '',
            city: '',
            street: '',
            zip_code: '',
            mobile_number: '',
            phone_number: '',
            email: ''
          },
          ...supplierData
        }}
      />
    </React.Fragment>
  );
};

export default SupplierFormPage;
